import { Phone, MessageCircle, ClipboardList } from "lucide-react";
import { phoneTel, waLink, DEFAULT_WA_MSG } from "../../lib/constants";
import { useSettings } from "../../lib/SettingsContext";

export const StickyBar = ({ onRequest }) => {
  const s = useSettings();

  return (
  <div
    data-testid="sticky-mobile-bar"
    className="fixed bottom-0 inset-x-0 z-50 md:hidden bg-black/90 backdrop-blur-md border-t border-yellow-400/30 p-3 grid grid-cols-3 gap-2 shadow-2xl"
  >
    <a
      data-testid="sticky-call-btn"
      href={phoneTel(s.phone_display)}
      className="flex items-center justify-center gap-1.5 bg-yellow-400 text-black font-bold text-sm py-3 rounded-full"
    >
      <Phone className="w-4 h-4" />
      اتصل الآن
    </a>
    <a
      data-testid="sticky-whatsapp-btn"
      href={waLink(DEFAULT_WA_MSG, s.whatsapp)}
      target="_blank"
      rel="noopener noreferrer"
      className="flex items-center justify-center gap-1.5 border border-green-500/50 text-green-400 font-bold text-sm py-3 rounded-full"
    >
      <MessageCircle className="w-4 h-4" />
      واتساب
    </a>
    <button
      data-testid="sticky-request-btn"
      onClick={() => onRequest()}
      className="flex items-center justify-center gap-1.5 border border-[#28282D] text-white font-bold text-sm py-3 rounded-full"
    >
      <ClipboardList className="w-4 h-4" />
      اطلب خدمة
    </button>
  </div>
  );
};
